import moment from "moment";
import "moment/locale/sv";
import "moment/locale/fi";

const formatTime = (time, locale) => {

  if(!locale) return time;

  moment.locale(locale);
  return moment(time).format("HH:mm");
};

export default formatTime;
